import React from 'react';
import { ChevronDown, FileText } from 'lucide-react';
import { marked } from 'marked';

export function About({ aboutExpanded, setAboutExpanded, selectedCollection }) {
  if (!selectedCollection) {
    return null;
  }

  return (
    <div
      style={{
        marginBottom: aboutExpanded ? 'clamp(16px, 3vw, 24px)' : '0',
        overflow: 'hidden',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        maxHeight: aboutExpanded ? '5000px' : '0',
        opacity: aboutExpanded ? 1 : 0,
      }}
    >
      <div
        style={{
          background: 'var(--theme-surface, #f8f9fa)',
          borderRadius: 'clamp(12px, 2vw, 16px)',
          border: '1px solid var(--theme-border, #dee2e6)',
          padding: 'clamp(16px, 3vw, 24px)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          transform: aboutExpanded ? 'translateY(0)' : 'translateY(-10px)',
          transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: aboutExpanded ? 'clamp(12px, 2vw, 16px)' : '0',
            transition: 'margin-bottom 0.4s ease',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: 'clamp(18px, 4vw, 22px)',
              fontWeight: 600,
              color: 'var(--theme-text, #212529)',
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(6px, 1.5vw, 8px)',
            }}
          >
            <span>About this Collection</span>
          </h2>
          <button
            onClick={() => setAboutExpanded(!aboutExpanded)}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--theme-textSecondary, #6c757d)',
              transition: 'all 0.2s ease',
              minWidth: '44px',
              minHeight: '44px',
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--theme-hover, #f8f9fa)';
              e.currentTarget.style.color = 'var(--theme-text, #212529)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = 'var(--theme-textSecondary, #6c757d)';
            }}
            aria-label={aboutExpanded ? 'Collapse' : 'Expand'}
          >
            <ChevronDown
              size={20}
              style={{
                transform: aboutExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          </button>
        </div>
        {aboutExpanded && (
          <div
            style={{
              paddingTop: 'clamp(12px, 2vw, 16px)',
              borderTop: '1px solid var(--theme-border, #dee2e6)',
            }}
          >
            {selectedCollection?.sharableData?.about ? (
              <div
                className="markdown-content"
                style={{
                  padding: 0,
                  background: 'transparent',
                  border: 'none',
                  boxShadow: 'none',
                  borderRadius: 0,
                  margin: 0,
                  maxWidth: '100%',
                }}
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    const renderer = new marked.Renderer();
                    renderer.link = function ({ href, text }) {
                      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
                    };
                    marked.setOptions({ renderer, breaks: true });
                    return marked.parse(selectedCollection.sharableData.about);
                  })()
                }}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 'clamp(32px, 6vw, 48px) clamp(16px, 4vw, 32px)',
                  textAlign: 'center',
                }}
              >
                <FileText
                  size={48}
                  style={{
                    color: 'var(--theme-textSecondary, #6c757d)',
                    marginBottom: 'clamp(12px, 2vw, 16px)',
                    opacity: 0.6,
                  }}
                />
                <p
                  style={{
                    margin: 0,
                    fontSize: 'clamp(16px, 3vw, 18px)',
                    fontWeight: 500,
                    color: 'var(--theme-text, #212529)',
                    marginBottom: 'clamp(8px, 1.5vw, 12px)',
                  }}
                >
                  No information available
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: 'clamp(14px, 2.5vw, 16px)',
                    fontWeight: 400,
                    color: 'var(--theme-textSecondary, #6c757d)',
                    lineHeight: 1.5,
                    maxWidth: '400px',
                  }}
                >
                  This collection doesn't have any additional information at the moment.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
